module.exports = __webpack_public_path__ + "img/c03_unithorseman_Normal_ua.2db8173d.webp";